import React from 'react';
import EmbedInstagramPost from './EmbedInstagramPost';
import styles from '../InstagramMessage.module.scss';
const Comment = ({ comment }) => {
    return (React.createElement("div", { className: styles.messageContainer },
        React.createElement("div", null, comment === null || comment === void 0 ? void 0 : comment.text),
        (comment === null || comment === void 0 ? void 0 : comment.media.permalink) && (React.createElement(EmbedInstagramPost, { permalink: comment.media.permalink, caption: comment.media.caption }))));
};
export default Comment;
